import config from "@/config";

/** Determines if user supports webp format @link https://stackoverflow.com/questions/5573096 */
// prettier-ignore
const getSupportsWebP = () => {
  if (process.env.NODE_ENV == 'test') {
    return false;
  }
  return window.document.createElement("canvas").toDataURL("image/webp").indexOf("data:image/webp") == 0;
}
// caches the result of the function the first time it's called
let supportsWebP: any;

export enum Filter {
  BlackAndWhite = "b",
  Blur = "l1",
}

export enum FileExtension {
  Original = "original",
  Optimal = "optimal",
  Webp = "webp",
  Png = "png",
  Jpg = "jpg",
}

const WIDTH_AUTO = 0;
const HEIGHT_AUTO = 0;

export type ImageSourceOptions = {
  width?: number;
  height?: number;
  filter?: Filter;
  extension?: FileExtension;
};

/**
 * Generates the URL for an image hosted in the CDN, applying transformations
 */
export const getImageSource = (
  path: string,
  {
    width = WIDTH_AUTO,
    height = HEIGHT_AUTO,
    filter = undefined,
    extension = FileExtension.Original,
  }: ImageSourceOptions = {}
) => {
  if (typeof path !== "string") {
    return null;
  }

  // For easy manipulation, remove the first "/" if present.
  path = path.replace(/^\//, "");

  if (width || height) {
    // adds "_{width}x{height}" immediately before the file extension
    path = path.replace(/(\.[^/.]+)$/, `_${width}x${height}$1`);
  }

  if (filter) {
    // add filter at the end, just before the extension
    path = path.replace(/(\.[^/.]+)$/, `_${filter}$1`);
  }

  if (extension !== FileExtension.Original) {
    // Get and cache webP compatibility
    supportsWebP =
      typeof supportsWebP === "undefined"
        ? (supportsWebP = getSupportsWebP())
        : supportsWebP;

    if (extension === FileExtension.Optimal) {
      extension = supportsWebP ? FileExtension.Webp : FileExtension.Jpg; // null indicates to not change extension
    }

    if (extension !== null && extension !== undefined) {
      // replace the extension
      path = path.replace(/\.[^/.]+$/, `.${extension}`);
    }
  }

  // Add base url if not present
  if (path.startsWith("images/")) {
    path = `${config.IMAGES_HOST}/${path}`;
  }

  return path;
};
